import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { DatePreview } from '../components/date';
import { ImagePreview } from '../components/image';
import { LongTextPreview } from '../components/longtext';
import { MapAttributionPreview } from '../components/mapattribution';
import { MapPreview } from '../components/map';
import { MapScalePreview } from '../components/mapscale';
import { MapScaleLinePreview } from '../components/mapscaleline';
import { MapOverviewPreview } from '../components/mapoverview';
import { RenderPreview } from '../components/render';
import { TextPreview } from '../components/text';
export class PreviewBuilder extends React.PureComponent {
    components = {
        DatePreview,
        ImagePreview,
        LongTextPreview,
        MapAttributionPreview,
        MapPreview,
        MapScalePreview,
        MapScaleLinePreview,
        MapOverviewPreview,
        RenderPreview,
        TextPreview,
    };
    render() {
        return (_jsx(_Fragment, { children: Object.keys(this.props.components).map((componentId) => {
                const component = this.props.components[componentId], Component = this.components[`${component.type}Preview`];
                if (!Component) {
                    console.warn(`Repex: unknown component type "${component.type}" for Preview`);
                    return null;
                }
                const area = component.areas[this.props.pageNum];
                if (!area)
                    return null;
                return !component.isPreviewHidden ? (_jsxs(React.Fragment, { children: [_jsx("style", { children: 
                            // Legacy browsers musi posilat CSS rules, ktere potrebuje Chrome na strane sluzby
                            `
                                    @media print {
                                        .rpx-pageArea-${componentId} {
                                            grid-area: ${componentId};
                                            ${component.place
                                ? `place-self: ${component.place};`
                                : ''}
                                        }
                                    }
                                ` }), _jsx("div", { className: `rpx-pageArea rpx-pageArea-${componentId}`, style: {
                                gridArea: componentId,
                                placeSelf: component.place,
                            }, children: _jsx(Component, { componentIdent: componentId }) })] }, componentId)) : null;
            }) }));
    }
}
//# sourceMappingURL=previewbuilder.js.map